import { SemanticUI } from '@iterable/deprecated_react_components';
import { StyledAccordion } from './BasePanel.styled';

// type Props = {
//   /** If panel is currently active. */
//   active: boolean,
//   /** Contents of accordion. */
//   children: any,
//   /** Index of panel according to order of the panel in the accordion. */
//   index: number,
//   /** Callback function when title is clicked. */
//   onTitleClick: ({}, {}) => void,
//   /** The title of the accordion. */
//   title: string,
// };

const BasePanel = ({ active, children, index, onTitleClick, title }) => {
  return (
    <StyledAccordion>
      <SemanticUI.Accordion.Title
        active={active}
        className="cssBasePanelTitle"
        index={index}
        onClick={onTitleClick}
      >
        <SemanticUI.Icon name="dropdown" />
        <span>{title}</span>
      </SemanticUI.Accordion.Title>
      <SemanticUI.Accordion.Content active={active} className="cssBasePanelContent">
        {children}
      </SemanticUI.Accordion.Content>
    </StyledAccordion>
  );
};

export default BasePanel;
